export default {
    key: 'swp',
    common: {
        productName: 'core.productNames.swp',
        splashMessage: 'offerFlow.splashMessage.swp',
        headingAside: 'offerFlow.headingAside.swp',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.swp',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.swp',
        body: 'offerFlow.pages.stepPassengers.body.swp',
    },
} satisfies OfferFlowContent;
